import { useMemo } from "react";
// 1. Đổi import từ CartItem sang ProductItem (type mới)
import { ProductItem } from "../../api/QuickOrder";

interface RightContentProps {
    // 2. Cập nhật type props
    cartItems: ProductItem[];
}

export default function RightContentQuickOrder({ cartItems = [] }: RightContentProps) {

    // 3. Tính tổng số lượng 
    // Lưu ý: item.quantity có thể undefined nên cần || 0
    const totalQuantity = useMemo(() => {
        return cartItems.reduce((total, item) => total + (item.quantity || 0), 0);
    }, [cartItems]);

    // 4. Tính tổng tiền
    // SỬA LỖI: Dùng trực tiếp item.price thay vì item.product.price
    const totalPrice = useMemo(() => {
        return cartItems.reduce((total, item) => {
            const price = item.price || 0;
            const quantity = item.quantity || 0;
            return total + (price * quantity);
        }, 0);
    }, [cartItems]);

    // 5. Hàm format tiền tệ
    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);
    }

    return (
        <div className="styles_cart___t_W5">
            <h3 className="styles_cartTitle__HN77U hidden-1199">Giỏ hàng</h3>
            <div className="styles_cartTop__Tjqh0">
                <div className="styles_cartItem__lzzsO">
                    <p className="styles_cartDesc__vgi2G">Số lượng</p>
                    {/* Hiển thị tổng số lượng */}
                    <p className="styles_cartText__wJejn">{totalQuantity}</p>
                </div>
            </div>
            <div className="styles_cartBottom__H3Y2o">
                <div className="styles_cartItem__lzzsO">
                    <p className="styles_cartDesc__vgi2G styles_bold__Erruu">Tạm tính</p>
                    {/* Hiển thị tổng tiền đã format */}
                    <p className="styles_cartText__wJejn styles_cartPrimary__sjJnj">
                        {formatCurrency(totalPrice)}
                    </p>
                </div>
                <div className="mt-20-1199-0">
                    <a className="styles_btnSubmit__hiIAd" href="/cart" title="Qua lại trang giỏ hàng">
                        <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0, position: "relative", maxWidth: "100%" }}>
                            <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0, maxWidth: "100%" }}>
                                <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0 }}></img>
                                <img src="https://cdn-web-next.thuocsi.vn/icons/cart_store.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: 0, boxSizing: "border-box", padding: 0, border: "none", margin: "auto", display: "block", width: 0, height: 0, minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }}></img>
                            </span>
                        </span>
                        <p className="MuiTypography-root MuiTypography-body2 hidden-1199">XEM GIỎ HÀNG</p>
                    </a>
                </div>
            </div>
        </div>
    )
}